import { instance as axios } from "@/store/_AXIOS"
import { _TOKEN, _DECODE } from "@/store/_JWT"

const TABLE = "/localidade/"

// initial state
const state = {
  distritos: [],
  defaultConcelhos: [],
  concelhos: []
}

// getters
const getters = {
  getAll: state => {
    return state.data
  },
  getDistrito: state => id => {
    if (
      !id ||
      state.distritos.length == 0 ||
      typeof state.distritos.find(el => {
        return el.id_distrito == id
      }) == "undefined"
    )
      return "-"
    return state.distritos.find(el => {
      return el.id_distrito == id
    }).nome
  },
  getDistritos(state) {
    return state.distritos
  },
  getConcelhos(state) {
    return state.concelhos
  },
  getDefault(state) {
    return state.defaultConcelhos
  }
}

// actions
const actions = {
  getAllDistritos({ commit }) {
    return axios
      .get("/distrito/")
      .then(res => {
        _DECODE(res.data.data).then(r => {
          if (r) commit("setDistritos", r)
          else commit("setDistritos", null)
        })
      })
      .catch(err => {
        commit("setDistritos", null)
      })
  },

  getConcelhos({ commit }, params) {
    return axios
      .post("/concelho/params/", _TOKEN(params))
      .then(res => {
        return _DECODE(res.data.data).then(r => {
          if (r) return r
          else return null
        })
      })
      .catch(err => {
        return null
      })
  },

  getLocalidades({ commit }, params) {
    return axios
      .post("/localidade/params/", _TOKEN(params))
      .then(res => {
        return _DECODE(res.data.data).then(r => {
          if (r) return r
          return null
        })
      })
      .catch(err => {
        return null
      })
  }
}

// mutations
const mutations = {
  setDistritos(state, distritos) {
    state.distritos = distritos ? distritos : []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
